var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 3.0125,
    width: 14.8857,
    height: 15.7905,
    stroke: "#727272",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.904297 7.73438L15.3805 7.73438",
    stroke: "#727272",
    strokeWidth: 1.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.61914,
    y: 10.4531,
    width: 1.80952,
    height: 1.80952,
    fill: "#727272"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.61914,
    y: 14.0703,
    width: 1.80952,
    height: 1.80952,
    fill: "#727272"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.23828,
    y: 14.0703,
    width: 1.80952,
    height: 1.80952,
    fill: "#727272"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.23828,
    y: 10.4531,
    width: 1.80952,
    height: 1.80952,
    fill: "#727272"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8574,
    y: 10.4531,
    width: 1.80952,
    height: 1.80952,
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52344 0.5V2.30952",
    stroke: "#727272",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7617 0.5V2.30952",
    stroke: "#727272",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendar);
export default __webpack_public_path__ + "static/media/ico-calendar.d570c5cdd54556dcf1fed7d185973e9d.svg";
export { ForwardRef as ReactComponent };